import { render, staticRenderFns } from "./ContactDash.vue?vue&type=template&id=cbbc4908&scoped=true&"
import script from "./ContactDash.vue?vue&type=script&lang=js&"
export * from "./ContactDash.vue?vue&type=script&lang=js&"
import style0 from "./ContactDash.vue?vue&type=style&index=0&id=cbbc4908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbbc4908",
  null
  
)

export default component.exports